import React from 'react';

function ProjectLeft({data}) {
    return (
        <div className="projectLeft" data-aos="fade-right" data-aos-delay="300">
            <div className="projectLeft__img">
                <img src={data.imageURL} alt="Project" />
            </div>
            <div className="projectLeft__description">
                <span className="projectLeft__description__name">{data.name}</span>
                <span className="projectLeft__description__text">{data.text}</span>
            </div>
        </div>
    )
}

export default ProjectLeft
